<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear ssystem college department sclass date keyword="學號、學生姓名">
                </query>
                <btn-group :load="reload" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度</th>
                            <th>學號-學生姓名</th>
                            <th>檢查日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.HealthexaminationID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.HealthexaminationID" /></td>
                        <td data-th="學年度">{{item.SYear}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.HealthexaminationID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="檢查日期">{{item.Date|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit"></Detail>
        <inputmodal id="input" url="/api/healthexamination/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './healthexaminationDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'healthexamination',
        api: '/api/healthexamination/',
        components: { Detail },
        query: { track: false, Semester: "" }
    });
</script>

<style>
</style>